const it = require('./bookTariffsLang/it');
const de = require('./bookTariffsLang/de');
const fr = require('./bookTariffsLang/fr');
const ro = require('./bookTariffsLang/ro');
const hr = require('./bookTariffsLang/hr');
const {
    lite2024CommonName,
    professional2024CommonName,
    expert2024CommonName,
    ultimate2025CommonName,
} = require('./bookTariffsLang/common-book-tariffs');

const {
    FREELANCER_2024_MONTH_COMPATIBILITY_CZK,
    FREELANCER_2024_YEAR_COMPATIBILITY_CZK,
    FREELANCER_2024_MONTH_COMPATIBILITY_EUR,
    FREELANCER_2024_YEAR_COMPATIBILITY_EUR,
    FREELANCER_2024_MONTH_COMPATIBILITY_USD,
    FREELANCER_2024_YEAR_COMPATIBILITY_USD,
    FREELANCER_2024_MONTH_COMPATIBILITY_HUF,
    FREELANCER_2024_YEAR_COMPATIBILITY_HUF,
    FREELANCER_2024_MONTH_COMPATIBILITY_PLN,
    FREELANCER_2024_YEAR_COMPATIBILITY_PLN,
    FREELANCER_2024_MONTH_COMPATIBILITY_GBP,
    FREELANCER_2024_YEAR_COMPATIBILITY_GBP,
    STUDIO_2024_MONTH_COMPATIBILITY_CZK,
    STUDIO_2024_YEAR_COMPATIBILITY_CZK,
    STUDIO_2024_MONTH_COMPATIBILITY_EUR,
    STUDIO_2024_YEAR_COMPATIBILITY_EUR,
    STUDIO_2024_MONTH_COMPATIBILITY_USD,
    STUDIO_2024_YEAR_COMPATIBILITY_USD,
    STUDIO_2024_MONTH_COMPATIBILITY_HUF,
    STUDIO_2024_YEAR_COMPATIBILITY_HUF,
    STUDIO_2024_MONTH_COMPATIBILITY_PLN,
    STUDIO_2024_YEAR_COMPATIBILITY_PLN,
    STUDIO_2024_MONTH_COMPATIBILITY_GBP,
    STUDIO_2024_YEAR_COMPATIBILITY_GBP,
    LITE_2024_MONTH_CZK,
    LITE_2024_YEAR_CZK,
    PROFESSIONAL_2024_MONTH_CZK,
    PROFESSIONAL_2024_YEAR_CZK,
    LITE_2024_MONTH_EUR,
    LITE_2024_YEAR_EUR,
    PROFESSIONAL_2024_MONTH_EUR,
    PROFESSIONAL_2024_YEAR_EUR,
    LITE_2024_MONTH_USD,
    LITE_2024_YEAR_USD,
    PROFESSIONAL_2024_MONTH_USD,
    PROFESSIONAL_2024_YEAR_USD,
    LITE_2024_MONTH_HUF,
    LITE_2024_YEAR_HUF,
    PROFESSIONAL_2024_MONTH_HUF,
    PROFESSIONAL_2024_YEAR_HUF,
    LITE_2024_MONTH_PLN,
    LITE_2024_YEAR_PLN,
    PROFESSIONAL_2024_MONTH_PLN,
    PROFESSIONAL_2024_YEAR_PLN,
    LITE_2024_MONTH_GBP,
    LITE_2024_YEAR_GBP,
    PROFESSIONAL_2024_MONTH_GBP,
    PROFESSIONAL_2024_YEAR_GBP,
    EXPERT_2024_MONTH_CZK,
    EXPERT_2024_YEAR_CZK,
    EXPERT_2024_MONTH_EUR,
    EXPERT_2024_YEAR_EUR,
    EXPERT_2024_MONTH_USD,
    EXPERT_2024_YEAR_USD,
    EXPERT_2024_MONTH_HUF,
    EXPERT_2024_YEAR_HUF,
    EXPERT_2024_YEAR_PLN,
    EXPERT_2024_MONTH_GBP,
    EXPERT_2024_YEAR_GBP,
    EXPERT_2024_MONTH_PLN,
    ULTIMATE_2025_YEAR_CZK,
    ULTIMATE_2025_MONTH_CZK,
    ULTIMATE_2025_MONTH_EUR,
    ULTIMATE_2025_YEAR_EUR,
    ULTIMATE_2025_MONTH_USD,
    ULTIMATE_2025_YEAR_USD,
    ULTIMATE_2025_MONTH_HUF,
    ULTIMATE_2025_YEAR_HUF,
    ULTIMATE_2025_MONTH_PLN,
    ULTIMATE_2025_YEAR_PLN,
    ULTIMATE_2025_MONTH_GBP,
    ULTIMATE_2025_YEAR_GBP,
} = require(`./stripebookTariffs`);
const { TRIAL_TARIFF_DAYS_DURATION } = require('./appConstants');

const DEPRECATED = {
    name: 'not available',
    description: 'tarif no longer available',
};
// CS
const csFreelancerMonthName = `Profesionál`;
const csFreelancerYearName = `Profesionál`;
const csStudioMonthName = `Studio`;
const csStudioYearName = `Studio`;
const csStudioProMonthName = `Studio PRO`;
const csStudioProYearName = `Studio PRO`;
// SK
const skFreelancerMonthName = `Profesionál`;
const skFreelancerYearName = `Profesionál`;
const skStudioMonthName = `Štúdio`;
const skStudioYearName = `Štúdio`;
const skStudioProMonthName = `Štúdio PRO`;
const skStudioProYearName = `Štúdio PRO`;
// EN
const enFreelancerMonthName = `Professional`;
const enFreelancerYearName = `Professional`;
const enStudioMonthName = `Studio`;
const enStudioYearName = `Studio`;
const enStudioProMonthName = `Studio PRO`;
const enStudioProYearName = `Studio PRO`;

// HU
const huFreelancerMonthName = `Oktató+`;
const huFreelancerYearName = `Oktató+`;
const huStudioMonthName = `Stúdió`;
const huStudioYearName = `Stúdió`;
const huStudioProMonthName = `Stúdió PRO`;
const huStudioProYearName = `Stúdió PRO`;
// PL
const plFreelancerMonthName = `Profesionalista`;
const plFreelancerYearName = `Profesionalista`;
const plStudioMonthName = `Studio`;
const plStudioYearName = `Studio`;
const plStudioProMonthName = `Studio PRO`;
const plStudioProYearName = `Studio PRO`;
// ES
const esFreelancerMonthName = `Profesional`;
const esFreelancerYearName = `Profesional`;
const esStudioMonthName = `Estudio`;
const esStudioYearName = `Estudio`;
const esStudioProMonthName = `Estudio PRO`;
const esStudioProYearName = `Estudio PRO`;
// PT
const ptBrFreelancerMonthName = `Profissional`;
const ptBrFreelancerYearName = `Profissional`;
const ptBrStudioMonthName = `Estúdio`;
const ptBrStudioYearName = `Estúdio`;
const ptBrStudioProMonthName = `Estúdio PRO`;
const ptBrStudioProYearName = `Estúdio PRO`;

// CS
const csFreelancerDescription = `Jsem 1 lektor. Pořádám otevřené lekce, kurzy nebo workshopy.`;
const csStudioDescription = `Pořádáme kurzy, otevřené lekce nebo workshopy, které vede více různých lektorů.`;
// SK
const skFreelancerDescription = `Som 1 lektor. Organizujem otvorené lekcie, kurzy alebo workshopy.`;
const skStudioDescription = `Organizujeme kurzy, otvorené lekcie alebo workshopy, ktoré vedie viacero rôznych lektorov.`;
// EN
const enFreelancerDescription = `I am an individual teacher. I organize workshops, open classes and courses.`;
const enStudioDescription = `We organize classes several times a week, led by several different teachers.`;
// HU
const huFreelancerDescription = `Egyéni oktató vagyok. Tanfolyamokat és órákat, és néha akár többnapos workshopokat is szervezek.`;
const huStudioDescription = `Számos óránk van hetente, amelyeket több tanár tart.`;

// PL
const plFreelancerDescription = `Jestem niezależnym instruktorem. Organizuję otwarte zajęcia, kursy i warsztaty.`;
const plStudioDescription = `Jest nas więcej. Organizujemy kursy, otwarte zajęcia i warsztaty. Zajęcia prowadzi kilku różnych instruktorów.`;

// ES
const esFreelancerDescription = `Soy un/a instructor/a independiente. Organizo talleres, clases sueltas y cursos.`;
const esStudioDescription = `Organizamos clases varias veces por semana, impartidas por diferentes instructores.`;

// PT-BR
const ptBrFreelancerDescription = `Sou um/a instrutor/a independente. Organizo workshops, aulas avulsas e cursos.`;
const ptBrStudioDescription = `Organizamos aulas várias vezes por semana, ministradas por diferentes instrutores.`;

const lite2024CommonDescription = {
    cs: `Pořádám pravidelné týdenní lekce a občas zorganizuji specializovaný víkendový workshop. Mé lekce jsou určeny pro pravidelné účastníky.`,
    sk: `Pořádám pravidelné týždenné lekcie a občas zorganizujem špecializovaný víkendový workshop. Moje lekcie sú určené pre pravidelných účastníkov.`,
    en: `I hold regular weekly classes and occasionally organize specialized weekend workshops. My classes are intended for regular participants.`,
    hu: `Heti rendszerességgel tartok órákat és alkalmanként speciális hétvégi workshopot szervezek. Az óráim rendszeres résztvevőknek szólnak.`,
    pl: `Prowadzę regularne cotygodniowe zajęcia i od czasu do czasu organizuję specjalistyczne warsztaty weekendowe. Moje zajęcia przeznaczone są dla stałych uczestników.`,
    es: `Imparto clases regulares cada semana y, ocasionalmente, organizo talleres especializados los fines de semana. Mis clases están dirigidas a participantes habituales.`,
    'pt-BR': `Ministro aulas regulares semanalmente e, ocasionalmente, organizo workshops especializados nos fins de semana. Minhas aulas são direcionadas a participantes regulares.`,
};
const professional2024CommonDescription = {
    cs: `Mám již ustálenou praxi a stálé klienty, kteří se ke mně opakovaně vrací. Pořádám více lekcí týdně a dlouhodobé kurzy s více termíny.`,
    sk: `Mám už ustálený biznis a stálych klientov, ktorí sa ku mne opakovane vracajú. Organizujem viac lekcií týždenne a dlhodobé kurzy s viacerými termínmi.`,
    en: `I have an established business and regular clients who return to me repeatedly. I hold multiple classes per week and long-term courses with several sessions.`,
    hu: `Megalapozott praxissal és rendszeres ügyfelekkel rendelkezem, akik ismételten visszatérnek hozzám. Heti több órát tartok és hosszú távú tanfolyamokat több időpontban.`,
    pl: `Mam ugruntowaną praktykę i stałych klientów, którzy wielokrotnie do mnie wracają. Prowadzę wiele zajęć tygodniowo i długoterminowe kursy z wieloma terminami.`,
    es: `Tengo un negocio consolidado y clientes fieles que regresan. Imparto varias clases a la semana y cursos de larga duración con múltiples sesiones.`,
    'pt-BR': `Tenho um negócio consolidado e clientes fiéis que retornam. Ministro várias aulas por semana e cursos de longa duração com várias sessões.`,
};

const expert2024CommonDescription = {
    cs: `Jsem samostatný expert nebo studio s týmem dvou a více lektorů. Naše nabídka zahrnuje široké spektrum lekcí, speciální workshopy a pravidelné tematické kurzy.`,
    sk: `Som samostatný expert alebo štúdio s tímom dvoch a viacerých lektorov. Naša ponuka zahŕňa široké spektrum lekcií, špeciálne workshopy a pravidelné tematické kurzy.`,
    en: `I am an independent expert or a studio with a team of two or more instructors. Our offerings include a wide range of classes, special workshops, and regular thematic courses.`,
    hu: `Két vagy több tanárból álló stúdiót működtetünk. Kínálatunkban órák, speciális workshopok és rendszeres tematikus tanfolyamok széles választéka szerepel.`,
    pl: `Jsem expert nebo prowadzimy studio z zespołem dwóch lub więcej instruktorów. Nasza oferta obejmuje szeroki zakres zajęć, specjalne warsztaty i regularne kursy tematyczne.`,
    es: `Soy un/a experto/a independiente o un estudio con un equipo de dos o más instructores. Nuestra oferta incluye una amplia variedad de clases, talleres especiales y cursos temáticos regulares.`,
    'pt-BR': `Sou um/a especialista independente ou um estúdio com uma equipe de dois ou mais instrutores. Nossa oferta inclui uma ampla variedade de aulas, workshops especiais e cursos temáticos regulares.`,
};

const ultimate2025CommonDescription = {
    cs: `Ideální volba, pokud chcete něco jedinečného a využívat Zenamu bez jakýchkoliv omezení.`,
    sk: `Ideálna voľba, ak chcete niečo jedinečné a využívať Zenamu bez akýchkoľvek obmedzení.`,
    en: `The perfect choice if you want something unique and to use Zenamu without any limitations.`,
    hu: `Ideális választás, ha valami egyedit szeretne, és korlátozások nélkül szeretné használni a Zenamut`,
    pl: `Idealny wybór, jeśli chcesz coś wyjątkowego i korzystać z Zenamu bez żadnych ograniczeń.`,
    es: `La opción ideal si buscas algo único y quieres usar Zenamu sin ninguna limitación.`,
    'pt-BR': `A escolha ideal se você deseja algo único e usar o Zenamu sem nenhuma limitação`,
};

/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    // free tariffs
    FREE: {
        id: 14,
        name: `FREE`,
        price: 0,
        cs: {
            name: `Začínající lektor`,
            description: `Lekce vypisuji nepravidelně a spíše příležitostně. Pořádám jen pár lekcí za měsíc pro menší skupinku zájemců.`,
        },
        sk: {
            name: `Začínajúci lektor`,
            description: `Lekcie vypisujem nepravidelne a skôr príležitostne. Organizujem len pár lekcií mesačne pre menšiu skupinku záujemcov.`,
        },
        en: {
            name: `Getting Started`,
            description: `I schedule classes irregularly and rather occasionally. I only hold a few classes per month for a small group of interested individuals.`,
        },
        hu: {
            name: `Kezdőcsomag`,
            description: `Rendszertelenül és inkább csak alkalmanként tartok órákat. Havonta csak pár órát szervezek az érdeklődők egy kis csoportja számára.`,
        },
        pl: {
            name: `Początkujący instruktor`,
            description: `Zajęcia wypisuję nieregularnie i raczej sporadycznie. Prowadzę tylko kilka zajęć w miesiącu dla niewielkiej grupy osób.`,
        },
        es: {
            name: `Primeros Pasos`,
            description: `Programo clases de manera ocasional, impartiendo solo unas pocas al mes para un grupo reducido de personas interesadas.`,
        },
        'pt-BR': {
            name: `Primeiros Passos`,
            description: `Programo aulas de forma ocasional, ministrando apenas algumas por mês para um grupo reduzido de pessoas interessadas.`,
        },
        de: de.FREE,
        fr: fr.FREE,
        it: it.FREE,
        hr: hr.FREE,
        ro: ro.FREE,
    },
    TRIAL_STUDIO: {
        id: 15,
        name: `TRIAL_STUDIO`,
        price: 0,
        de: de.TRIAL_STUDIO,
        fr: fr.TRIAL_STUDIO,
        it: it.TRIAL_STUDIO,
        hr: hr.TRIAL_STUDIO,
        ro: ro.TRIAL_STUDIO,
        cs: {
            name: `Zkušební verze s neomezenými funkcemi`,
            description: `S novou registrací získáváte na ${TRIAL_TARIFF_DAYS_DURATION} dní neomezenou verzi tarifu pro studia.`,
        },
        sk: {
            name: `Skúšobná verzia s neobmedzenými funkciami`,
            description: `S novou registráciou získavate na ${TRIAL_TARIFF_DAYS_DURATION} dní neobmedzenú verziu plánu pre štúdiá.`,
        },
        en: {
            name: `Trial version with unlimited features`,
            description: `You will try the "Studio" subscription free for ${TRIAL_TARIFF_DAYS_DURATION} days with a new registration.`,
        },
        hu: {
            name: `Díjmentes próbaverzió`,
            description: `A regisztrációval ${TRIAL_TARIFF_DAYS_DURATION} nap ingyenes használat érhető el!`,
        },
        pl: {
            name: `Bezpłatna wersja próbna z nieograniczonymi funkcjami.`,
            description: `Z nową rejestracją otrzymujesz na ${TRIAL_TARIFF_DAYS_DURATION} dni nieograniczoną wersję Zenamu. Dostęp do wszystkich nieograniczonych funkcji.`,
        },
        es: {
            name: `Versión de prueba con funciones ilimitadas`,
            description: `Con un nuevo registro, podrás probar la suscripción "Estudio" gratis durante ${TRIAL_TARIFF_DAYS_DURATION} días.`,
        },
        'pt-BR': {
            name: `Versão de teste com funções ilimitadas`,
            description: `Com um novo cadastro, você poderá experimentar a assinatura "Estúdio" gratuitamente por ${TRIAL_TARIFF_DAYS_DURATION} dias.`,
        },
    },
    TRIAL_FREELANCER: {
        id: 16,
        name: `TRIAL_FREELANCER`,
        price: 0,
        de: de.TRIAL_FREELANCER,
        fr: fr.TRIAL_FREELANCER,
        it: it.TRIAL_FREELANCER,
        hr: hr.TRIAL_FREELANCER,
        ro: ro.TRIAL_FREELANCER,
        cs: {
            name: `Zkušební verze s neomezenými funkcemi`,
            description: `S novou registrací získáváte na ${TRIAL_TARIFF_DAYS_DURATION} dní neomezenou verzi tarifu pro samostatné lektory.`,
        },
        sk: {
            name: `Skúšobná verzia s neobmedzenými funkciami`,
            description: `S novou registráciou získavate na ${TRIAL_TARIFF_DAYS_DURATION} dní neobmedzenú verziu plánu pre samostatných lektorov.`,
        },
        en: {
            name: `Trial version with unlimited features`,
            description: `You will try the Individual Teacher subscription free for ${TRIAL_TARIFF_DAYS_DURATION} days with a new registration.`,
        },
        hu: {
            name: `Díjmentes próbaverzió`,
            description: `A regisztrációval ${TRIAL_TARIFF_DAYS_DURATION} nap ingyenes használat érhető el!`,
        },
        pl: {
            name: `Bezpłatna wersja próbna z nieograniczonymi funkcjami.`,
            description: `Z nową rejestracją otrzymujesz na ${TRIAL_TARIFF_DAYS_DURATION} dni nieograniczoną wersję Zenamu. Dostęp do wszystkich nieograniczonych funkcji.`,
        },
        es: {
            name: `Versión de prueba con funciones ilimitadas`,
            description: `Con un nuevo registro, podrás probar la suscripción de "Instructor Independiente" gratis durante ${TRIAL_TARIFF_DAYS_DURATION} días.`,
        },
        'pt-BR': {
            name: `Versão de teste com funções ilimitadas`,
            description: `Com um novo cadastro, você poderá experimentar a assinatura "Instrutor Independente" gratuitamente por ${TRIAL_TARIFF_DAYS_DURATION} dias.`,
        },
    },
    // new stripe tariffs - but Legacy - to be compatible due to the migration (new pricing).
    // ##### FREELANCER
    // CZK
    LITE_2024_MONTH_CZK: {
        name: LITE_2024_MONTH_CZK.name,
        price: LITE_2024_MONTH_CZK.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    LITE_2024_YEAR_CZK: {
        name: LITE_2024_YEAR_CZK.name,
        price: LITE_2024_YEAR_CZK.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_MONTH_CZK: {
        name: PROFESSIONAL_2024_MONTH_CZK.name,
        price: PROFESSIONAL_2024_MONTH_CZK.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_YEAR_CZK: {
        name: PROFESSIONAL_2024_YEAR_CZK.name,
        price: PROFESSIONAL_2024_YEAR_CZK.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_MONTH_CZK: {
        name: EXPERT_2024_MONTH_CZK.name,
        price: EXPERT_2024_MONTH_CZK.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_YEAR_CZK: {
        name: EXPERT_2024_YEAR_CZK.name,
        price: EXPERT_2024_YEAR_CZK.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_MONTH_CZK: {
        name: ULTIMATE_2025_MONTH_CZK.name,
        price: ULTIMATE_2025_MONTH_CZK.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_YEAR_CZK: {
        name: ULTIMATE_2025_YEAR_CZK.name,
        price: ULTIMATE_2025_YEAR_CZK.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    // EUR
    LITE_2024_MONTH_EUR: {
        name: LITE_2024_MONTH_EUR.name,
        price: LITE_2024_MONTH_EUR.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    LITE_2024_YEAR_EUR: {
        name: LITE_2024_YEAR_EUR.name,
        price: LITE_2024_YEAR_EUR.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_MONTH_EUR: {
        name: PROFESSIONAL_2024_MONTH_EUR.name,
        price: PROFESSIONAL_2024_MONTH_EUR.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_YEAR_EUR: {
        name: PROFESSIONAL_2024_YEAR_EUR.name,
        price: PROFESSIONAL_2024_YEAR_EUR.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_MONTH_EUR: {
        name: EXPERT_2024_MONTH_EUR.name,
        price: EXPERT_2024_MONTH_EUR.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_YEAR_EUR: {
        name: EXPERT_2024_YEAR_EUR.name,
        price: EXPERT_2024_YEAR_EUR.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_MONTH_EUR: {
        name: ULTIMATE_2025_MONTH_EUR.name,
        price: ULTIMATE_2025_MONTH_EUR.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_YEAR_EUR: {
        name: ULTIMATE_2025_YEAR_EUR.name,
        price: ULTIMATE_2025_YEAR_EUR.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    // USD
    LITE_2024_MONTH_USD: {
        name: LITE_2024_MONTH_USD.name,
        price: LITE_2024_MONTH_USD.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    LITE_2024_YEAR_USD: {
        name: LITE_2024_YEAR_USD.name,
        price: LITE_2024_YEAR_USD.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_MONTH_USD: {
        name: PROFESSIONAL_2024_MONTH_USD.name,
        price: PROFESSIONAL_2024_MONTH_USD.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_YEAR_USD: {
        name: PROFESSIONAL_2024_YEAR_USD.name,
        price: PROFESSIONAL_2024_YEAR_USD.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_MONTH_USD: {
        name: EXPERT_2024_MONTH_USD.name,
        price: EXPERT_2024_MONTH_USD.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_YEAR_USD: {
        name: EXPERT_2024_YEAR_USD.name,
        price: EXPERT_2024_YEAR_USD.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_MONTH_USD: {
        name: ULTIMATE_2025_MONTH_USD.name,
        price: ULTIMATE_2025_MONTH_USD.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_YEAR_USD: {
        name: ULTIMATE_2025_YEAR_USD.name,
        price: ULTIMATE_2025_YEAR_USD.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    // HUF
    LITE_2024_MONTH_HUF: {
        name: LITE_2024_MONTH_HUF.name,
        price: LITE_2024_MONTH_HUF.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    LITE_2024_YEAR_HUF: {
        name: LITE_2024_YEAR_HUF.name,
        price: LITE_2024_YEAR_HUF.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_MONTH_HUF: {
        name: PROFESSIONAL_2024_MONTH_HUF.name,
        price: PROFESSIONAL_2024_MONTH_HUF.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_YEAR_HUF: {
        name: PROFESSIONAL_2024_YEAR_HUF.name,
        price: PROFESSIONAL_2024_YEAR_HUF.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_MONTH_HUF: {
        name: EXPERT_2024_MONTH_HUF.name,
        price: EXPERT_2024_MONTH_HUF.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_YEAR_HUF: {
        name: EXPERT_2024_YEAR_HUF.name,
        price: EXPERT_2024_YEAR_HUF.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_MONTH_HUF: {
        name: ULTIMATE_2025_MONTH_HUF.name,
        price: ULTIMATE_2025_MONTH_HUF.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_YEAR_HUF: {
        name: ULTIMATE_2025_YEAR_HUF.name,
        price: ULTIMATE_2025_YEAR_HUF.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    // PLN
    LITE_2024_MONTH_PLN: {
        name: LITE_2024_MONTH_PLN.name,
        price: LITE_2024_MONTH_PLN.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    LITE_2024_YEAR_PLN: {
        name: LITE_2024_YEAR_PLN.name,
        price: LITE_2024_YEAR_PLN.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_MONTH_PLN: {
        name: PROFESSIONAL_2024_MONTH_PLN.name,
        price: PROFESSIONAL_2024_MONTH_PLN.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_YEAR_PLN: {
        name: PROFESSIONAL_2024_YEAR_PLN.name,
        price: PROFESSIONAL_2024_YEAR_PLN.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_MONTH_PLN: {
        name: EXPERT_2024_MONTH_PLN.name,
        price: EXPERT_2024_MONTH_PLN.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_YEAR_PLN: {
        name: EXPERT_2024_YEAR_PLN.name,
        price: EXPERT_2024_YEAR_PLN.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_MONTH_PLN: {
        name: ULTIMATE_2025_MONTH_PLN.name,
        price: ULTIMATE_2025_MONTH_PLN.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_YEAR_PLN: {
        name: ULTIMATE_2025_YEAR_PLN.name,
        price: ULTIMATE_2025_YEAR_PLN.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    // GBP
    LITE_2024_MONTH_GBP: {
        name: LITE_2024_MONTH_GBP.name,
        price: LITE_2024_MONTH_GBP.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    LITE_2024_YEAR_GBP: {
        name: LITE_2024_YEAR_GBP.name,
        price: LITE_2024_YEAR_GBP.price,
        de: de.LITE_2024,
        fr: fr.LITE_2024,
        it: it.LITE_2024,
        hr: hr.LITE_2024,
        ro: ro.LITE_2024,
        cs: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.cs,
        },
        sk: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.sk,
        },
        en: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.en,
        },
        hu: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.hu,
        },
        pl: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.pl,
        },
        es: {
            name: lite2024CommonName,
            description: lite2024CommonDescription.es,
        },
        'pt-BR': {
            name: lite2024CommonName,
            description: lite2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_MONTH_GBP: {
        name: PROFESSIONAL_2024_MONTH_GBP.name,
        price: PROFESSIONAL_2024_MONTH_GBP.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    PROFESSIONAL_2024_YEAR_GBP: {
        name: PROFESSIONAL_2024_YEAR_GBP.name,
        price: PROFESSIONAL_2024_YEAR_GBP.price,
        de: de.PROFESSIONAL_2024,
        fr: fr.PROFESSIONAL_2024,
        it: it.PROFESSIONAL_2024,
        hr: hr.PROFESSIONAL_2024,
        ro: ro.PROFESSIONAL_2024,
        cs: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.cs,
        },
        sk: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.sk,
        },
        en: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.en,
        },
        hu: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.hu,
        },
        pl: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.pl,
        },
        es: {
            name: professional2024CommonName,
            description: professional2024CommonDescription.es,
        },
        'pt-BR': {
            name: professional2024CommonName,
            description: professional2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_MONTH_GBP: {
        name: EXPERT_2024_MONTH_GBP.name,
        price: EXPERT_2024_MONTH_GBP.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    EXPERT_2024_YEAR_GBP: {
        name: EXPERT_2024_YEAR_GBP.name,
        price: EXPERT_2024_YEAR_GBP.price,
        de: de.EXPERT_2024,
        fr: fr.EXPERT_2024,
        it: it.EXPERT_2024,
        hr: hr.EXPERT_2024,
        ro: ro.EXPERT_2024,
        cs: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.cs,
        },
        sk: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.sk,
        },
        en: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.en,
        },
        hu: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.hu,
        },
        pl: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.pl,
        },
        es: {
            name: expert2024CommonName,
            description: expert2024CommonDescription.es,
        },
        'pt-BR': {
            name: expert2024CommonName,
            description: expert2024CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_MONTH_GBP: {
        name: ULTIMATE_2025_MONTH_GBP.name,
        price: ULTIMATE_2025_MONTH_GBP.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    ULTIMATE_2025_YEAR_GBP: {
        name: ULTIMATE_2025_YEAR_GBP.name,
        price: ULTIMATE_2025_YEAR_GBP.price,
        de: de.ULTIMATE_2025,
        fr: fr.ULTIMATE_2025,
        it: it.ULTIMATE_2025,
        hr: hr.ULTIMATE_2025,
        ro: ro.ULTIMATE_2025,
        cs: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.cs,
        },
        sk: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.sk,
        },
        en: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.en,
        },
        hu: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.hu,
        },
        pl: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.pl,
        },
        es: {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription.es,
        },
        'pt-BR': {
            name: ultimate2025CommonName,
            description: ultimate2025CommonDescription['pt-BR'],
        },
    },
    /** ************************ DEPRECATED ****************************/
    // new stripe tariffs - but Legacy - to be compatible due to the migration (new pricing).
    // ##### FREELANCER
    // CZK
    FREELANCER_2024_MONTH_COMPATIBILITY_CZK: {
        name: FREELANCER_2024_MONTH_COMPATIBILITY_CZK.name,
        price: FREELANCER_2024_MONTH_COMPATIBILITY_CZK.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_CZK: {
        name: FREELANCER_2024_YEAR_COMPATIBILITY_CZK.name,
        price: FREELANCER_2024_YEAR_COMPATIBILITY_CZK.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    // EUR
    FREELANCER_2024_MONTH_COMPATIBILITY_EUR: {
        name: FREELANCER_2024_MONTH_COMPATIBILITY_EUR.name,
        price: FREELANCER_2024_MONTH_COMPATIBILITY_EUR.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_EUR: {
        name: FREELANCER_2024_YEAR_COMPATIBILITY_EUR.name,
        price: FREELANCER_2024_YEAR_COMPATIBILITY_EUR.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    // USD
    FREELANCER_2024_MONTH_COMPATIBILITY_USD: {
        name: FREELANCER_2024_MONTH_COMPATIBILITY_USD.name,
        price: FREELANCER_2024_MONTH_COMPATIBILITY_USD.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_USD: {
        name: FREELANCER_2024_YEAR_COMPATIBILITY_USD.name,
        price: FREELANCER_2024_YEAR_COMPATIBILITY_USD.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    // HUF
    FREELANCER_2024_MONTH_COMPATIBILITY_HUF: {
        name: FREELANCER_2024_MONTH_COMPATIBILITY_HUF.name,
        price: FREELANCER_2024_MONTH_COMPATIBILITY_HUF.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_HUF: {
        name: FREELANCER_2024_YEAR_COMPATIBILITY_HUF.name,
        price: FREELANCER_2024_YEAR_COMPATIBILITY_HUF.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    // PLN
    FREELANCER_2024_MONTH_COMPATIBILITY_PLN: {
        name: FREELANCER_2024_MONTH_COMPATIBILITY_PLN.name,
        price: FREELANCER_2024_MONTH_COMPATIBILITY_PLN.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_PLN: {
        name: FREELANCER_2024_YEAR_COMPATIBILITY_PLN.name,
        price: FREELANCER_2024_YEAR_COMPATIBILITY_PLN.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    // GBP
    FREELANCER_2024_MONTH_COMPATIBILITY_GBP: {
        name: FREELANCER_2024_MONTH_COMPATIBILITY_GBP.name,
        price: FREELANCER_2024_MONTH_COMPATIBILITY_GBP.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_GBP: {
        name: FREELANCER_2024_YEAR_COMPATIBILITY_GBP.name,
        price: FREELANCER_2024_YEAR_COMPATIBILITY_GBP.price,
        de: de.FREELANCER_2024_COMPATIBILITY,
        fr: fr.FREELANCER_2024_COMPATIBILITY,
        it: it.FREELANCER_2024_COMPATIBILITY,
        hr: hr.FREELANCER_2024_COMPATIBILITY,
        ro: ro.FREELANCER_2024_COMPATIBILITY,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    // ##### STUDIO
    // CZK
    STUDIO_2024_MONTH_COMPATIBILITY_CZK: {
        name: STUDIO_2024_MONTH_COMPATIBILITY_CZK.name,
        price: STUDIO_2024_MONTH_COMPATIBILITY_CZK.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_2024_YEAR_COMPATIBILITY_CZK: {
        name: STUDIO_2024_YEAR_COMPATIBILITY_CZK.name,
        price: STUDIO_2024_YEAR_COMPATIBILITY_CZK.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    // EUR
    STUDIO_2024_MONTH_COMPATIBILITY_EUR: {
        name: STUDIO_2024_MONTH_COMPATIBILITY_EUR.name,
        price: STUDIO_2024_MONTH_COMPATIBILITY_EUR.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_2024_YEAR_COMPATIBILITY_EUR: {
        name: STUDIO_2024_YEAR_COMPATIBILITY_EUR.name,
        price: STUDIO_2024_YEAR_COMPATIBILITY_EUR.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    // USD
    STUDIO_2024_MONTH_COMPATIBILITY_USD: {
        name: STUDIO_2024_MONTH_COMPATIBILITY_USD.name,
        price: STUDIO_2024_MONTH_COMPATIBILITY_USD.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_2024_YEAR_COMPATIBILITY_USD: {
        name: STUDIO_2024_YEAR_COMPATIBILITY_USD.name,
        price: STUDIO_2024_YEAR_COMPATIBILITY_USD.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    // HUF
    STUDIO_2024_MONTH_COMPATIBILITY_HUF: {
        name: STUDIO_2024_MONTH_COMPATIBILITY_HUF.name,
        price: STUDIO_2024_MONTH_COMPATIBILITY_HUF.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_2024_YEAR_COMPATIBILITY_HUF: {
        name: STUDIO_2024_YEAR_COMPATIBILITY_HUF.name,
        price: STUDIO_2024_YEAR_COMPATIBILITY_HUF.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    // PLN
    STUDIO_2024_MONTH_COMPATIBILITY_PLN: {
        name: STUDIO_2024_MONTH_COMPATIBILITY_PLN.name,
        price: STUDIO_2024_MONTH_COMPATIBILITY_PLN.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },

        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_2024_YEAR_COMPATIBILITY_PLN: {
        name: STUDIO_2024_YEAR_COMPATIBILITY_PLN.name,
        price: STUDIO_2024_YEAR_COMPATIBILITY_PLN.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    // GBP
    STUDIO_2024_MONTH_COMPATIBILITY_GBP: {
        name: STUDIO_2024_MONTH_COMPATIBILITY_GBP.name,
        price: STUDIO_2024_MONTH_COMPATIBILITY_GBP.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_2024_YEAR_COMPATIBILITY_GBP: {
        name: STUDIO_2024_YEAR_COMPATIBILITY_GBP.name,
        price: STUDIO_2024_YEAR_COMPATIBILITY_GBP.price,
        de: de.STUDIO_2024_COMPATIBILITY,
        fr: fr.STUDIO_2024_COMPATIBILITY,
        it: it.STUDIO_2024_COMPATIBILITY,
        hr: hr.STUDIO_2024_COMPATIBILITY,
        ro: ro.STUDIO_2024_COMPATIBILITY,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    // deprecated 2021 tariffs
    FREELANCER_2021_MONTH_CZK: {
        id: 1,
        name: `FREELANCER_2021_MONTH_CZK`,
        price: 270,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    STUDIO_2021_MONTH_CZK: {
        id: 2,
        name: `STUDIO_2021_MONTH_CZK`,
        price: 450,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_PRO_2021_MONTH_CZK: {
        id: 3,
        name: `STUDIO_PRO_2021_MONTH_CZK`,
        price: 750,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioProMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioProMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioProMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioProMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioProMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioProMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioProMonthName,
            description: ptBrStudioDescription,
        },
    },
    TRIAL: {
        id: 4,
        name: `TRIAL`,
        price: 0,
        de: de.TRIAL_STUDIO,
        fr: fr.TRIAL_STUDIO,
        it: it.TRIAL_STUDIO,
        hr: hr.TRIAL_STUDIO,
        ro: ro.TRIAL_STUDIO,
        cs: {
            name: `Zkušební verze s neomezenými funkcemi`,
            description: `S novou registrací získáváte zdarma na ${TRIAL_TARIFF_DAYS_DURATION} dní tarif "Studio".`,
        },
        sk: {
            name: `Skúšobná verzia s neobmedzenými funkciami`,
            description: `S novou registráciou získavate zdarma na ${TRIAL_TARIFF_DAYS_DURATION} dní plán "Studio".`,
        },
        en: {
            name: `Trial version with unlimited features`,
            description: `With a new registration, you get a free "Studio" subscription for ${TRIAL_TARIFF_DAYS_DURATION} days.`,
        },
        hu: {
            name: `Díjmentes próbaverzió`,
            description: `A regisztrációval ${TRIAL_TARIFF_DAYS_DURATION} nap ingyenes használat érhető el!`,
        },
        pl: {
            name: `Bezpłatna wersja próbna z nieograniczonymi funkcjami.`,
            description: `Z nową rejestracją otrzymujesz za darmo na ${TRIAL_TARIFF_DAYS_DURATION} dni taryfę "Studio".`,
        },
        es: {
            name: `Versión de prueba con funciones ilimitadas`,
            description: `Con un nuevo registro, obtendrás una suscripción gratuita de "Estudio" por ${TRIAL_TARIFF_DAYS_DURATION} días.`,
        },
        'pt-BR': {
            name: `Versão de teste com funções ilimitadas`,
            description: `Com um novo cadastro, você obterá uma assinatura gratuita de "Estúdio" por ${TRIAL_TARIFF_DAYS_DURATION} dias.`,
        },
    },
    FREELANCER_2021_YEAR_CZK: {
        id: 5,
        name: `FREELANCER_2021_YEAR_CZK`,
        price: 2970,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    STUDIO_2021_YEAR_CZK: {
        id: 6,
        name: `STUDIO_2021_YEAR_CZK`,
        price: 4950,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    STUDIO_PRO_2021_YEAR_CZK: {
        id: 7,
        name: `STUDIO_PRO_2021_YEAR_CZK`,
        price: 9000,
        cs: {
            name: csStudioProYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioProYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioProYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioProYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioProYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioProYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioProYearName,
            description: ptBrStudioDescription,
        },
    },
    // EUR
    FREELANCER_2021_MONTH_EUR: {
        id: 8,
        name: `FREELANCER_2021_MONTH_EUR`,
        price: 12,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    STUDIO_2021_MONTH_EUR: {
        id: 9,
        name: `STUDIO_2021_MONTH_EUR`,
        price: 20,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_PRO_2021_MONTH_EUR: {
        id: 10,
        name: `STUDIO_PRO_2021_MONTH_EUR`,
        price: 20,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioProMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioProMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioProMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioProMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioProMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioProMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioProMonthName,
            description: ptBrStudioDescription,
        },
    },
    FREELANCER_2021_YEAR_EUR: {
        id: 11,
        name: `FREELANCER_2021_YEAR_EUR`,
        price: 132,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    STUDIO_2021_YEAR_EUR: {
        id: 12,
        name: `STUDIO_2021_YEAR_EUR`,
        price: 220,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_PRO_2021_YEAR_EUR: {
        id: 13,
        name: `STUDIO_PRO_2021_YEAR_EUR`,
        price: 220,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioProYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioProYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioProYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioProYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioProYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioProYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioProYearName,
            description: ptBrStudioDescription,
        },
    },
    // USD
    FREELANCER_2021_MONTH_USD: {
        id: 17,
        name: `FREELANCER_2021_MONTH_USD`,
        price: 19,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csFreelancerMonthName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerMonthName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerMonthName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerMonthName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerMonthName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerMonthName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerMonthName,
            description: ptBrFreelancerDescription,
        },
    },
    STUDIO_2021_MONTH_USD: {
        id: 18,
        name: `STUDIO_2021_MONTH_USD`,
        price: 29,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioMonthName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_PRO_2021_MONTH_USD: {
        id: 19,
        name: `STUDIO_PRO_2021_MONTH_USD`,
        price: 29,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioProMonthName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioProMonthName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioProMonthName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioProMonthName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioProMonthName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioProMonthName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioProMonthName,
            description: ptBrStudioDescription,
        },
    },
    FREELANCER_2021_YEAR_USD: {
        id: 20,
        name: `FREELANCER_2021_YEAR_USD`,
        price: 209,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csFreelancerYearName,
            description: csFreelancerDescription,
        },
        sk: {
            name: skFreelancerYearName,
            description: skFreelancerDescription,
        },
        en: {
            name: enFreelancerYearName,
            description: enFreelancerDescription,
        },
        hu: {
            name: huFreelancerYearName,
            description: huFreelancerDescription,
        },
        pl: {
            name: plFreelancerYearName,
            description: plFreelancerDescription,
        },
        es: {
            name: esFreelancerYearName,
            description: esFreelancerDescription,
        },
        'pt-BR': {
            name: ptBrFreelancerYearName,
            description: ptBrFreelancerDescription,
        },
    },
    STUDIO_2021_YEAR_USD: {
        id: 21,
        name: `STUDIO_2021_YEAR_USD`,
        price: 317,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioYearName,
            description: ptBrStudioDescription,
        },
    },
    STUDIO_PRO_2021_YEAR_USD: {
        id: 22,
        name: `STUDIO_PRO_2021_YEAR_USD`,
        price: 317,
        de: DEPRECATED,
        fr: DEPRECATED,
        it: DEPRECATED,
        hr: DEPRECATED,
        ro: DEPRECATED,
        cs: {
            name: csStudioProYearName,
            description: csStudioDescription,
        },
        sk: {
            name: skStudioProYearName,
            description: skStudioDescription,
        },
        en: {
            name: enStudioProYearName,
            description: enStudioDescription,
        },
        hu: {
            name: huStudioProYearName,
            description: huStudioDescription,
        },
        pl: {
            name: plStudioProYearName,
            description: plStudioDescription,
        },
        es: {
            name: esStudioProYearName,
            description: esStudioDescription,
        },
        'pt-BR': {
            name: ptBrStudioProYearName,
            description: ptBrStudioDescription,
        },
    },
};
